var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "div",
        {
          class: [
            _vm.$style["ns-feature"],
            ((_obj = {}),
            (_obj[_vm.$style["right-align"]] =
              _vm.textAreaAlignment === "right"),
            _obj),
            ((_obj$1 = {}),
            (_obj$1[_vm.$style["half-image"]] = _vm.imageSize === "half"),
            _obj$1)
          ],
          style: {
            "background-color":
              _vm.imageSize === "half" && _vm.halfBackgroundColor
          }
        },
        [
          _c("div", {
            class: _vm.$style["feature-image"],
            style: { "background-image": "url(" + _vm.imageSrc + ")" }
          }),
          _vm._v(" "),
          _c("div", { class: _vm.$style["feature-block"] }, [
            _c("div", { class: _vm.$style["feature-text-area"] }, [
              _c("div", { class: _vm.$style["fta-title"] }, [
                _vm._v(_vm._s(_vm.title))
              ]),
              _vm._v(" "),
              _vm.description
                ? _c("div", {
                    class: _vm.$style["fta-description"],
                    domProps: { innerHTML: _vm._s(_vm.description) }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.ctaVisible
                ? _c(
                    "div",
                    { class: _vm.$style["fta-call-to-action"] },
                    [
                      _vm.ctaType === "button" || _vm.isMobile
                        ? _c(
                            "button",
                            {
                              staticClass: "btn-primary primary-outline",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.ctaClicked($event)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.ctaText) +
                                  "\n        "
                              )
                            ]
                          )
                        : _c(
                            "NsExpressiveLink",
                            { on: { click: _vm.ctaClicked } },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.ctaText) +
                                  "\n        "
                              )
                            ]
                          )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }